import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getNumberPrivateTrainingCenterRequest: ['response'],
    getNumberPrivateTrainingCenterSuccess: ['response', 'loading'],
    getNumberPrivateTrainingCenterFailure: ['error'],
})

export const getNumberPrivateTrainingCenterTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getNumberPrivateTrainingCenterSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getNumberPrivateTrainingCenterFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getNumberPrivateTrainingCenterRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_NUMBER_PRIVATE_TRAINING_CENTER_REQUEST]: getNumberPrivateTrainingCenterRequest,
    [Types.GET_NUMBER_PRIVATE_TRAINING_CENTER_SUCCESS]: getNumberPrivateTrainingCenterSuccess,
    [Types.GET_NUMBER_PRIVATE_TRAINING_CENTER_FAILURE]: getNumberPrivateTrainingCenterFailure,
})
